import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './ui/SectionHeading';
import { modules } from '../data/modules';
import { totalVolumes } from '../data/offer';
export function ModulesSection() {
  return <section className="py-16 sm:py-20" aria-labelledby="modules-title" data-id="element-111" data-mp="1iwcxjc03p0fu">
      <div className="mx-auto max-w-6xl px-4" data-id="element-112" data-mp="1dx07kidxnd91">
        <SectionHeading id="modules-title" data-id="element-113" data-mp="1dybakfzk0gz3">I {totalVolumes} <span className="text-energy" data-id="element-114" data-mp="2bkihhwjbylem">Volumi Completi</span></SectionHeading>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-115" data-mp="26l5t37ct969x">
          {modules.map((module, index) => {
          const Icon = module.icon;
          return <motion.article key={module.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.15
          }} transition={{
            duration: 0.3,
            delay: index % 3 * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col rounded-2xl border border-energy/25 bg-navy-card p-6 shadow-lg" data-id="element-116" data-mp="21k8348lk77xv" data-mpi={index}>
                <div className="flex items-center gap-3" data-id="element-117" data-mp="1nta70a5dhebq">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-aqua/40 bg-navy text-energy" data-id="element-118" data-mp="18x2orfdiymz3">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-119" data-mp="1duuhucpwof4v" />
                  </span>
                  <p className="text-xs font-bold uppercase tracking-[.14em] text-gold" data-id="element-120" data-mp="103pp7ukygn41">Volume {module.number}</p>
                </div>
                <h3 className="mt-4 text-xl font-extrabold uppercase leading-tight text-cream" data-id="element-121" data-mp="14xk6krd38pzy">{module.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-haze" data-id="element-122" data-mp="q4qfs9sd8nfz">{module.summary}</p>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}